import React from 'react';

import type { LegendGroup } from '../types/lottery';

interface PlayRuleLegendProps {
  groups?: LegendGroup[];
  title?: string;
}

const PlayRuleLegend: React.FC<PlayRuleLegendProps> = ({ groups, title = '玩法规则' }) => {
  if (!groups?.length) {
    return null;
  }

  return (
    <>
      <div className="play-rule-panel__title">
        <span className="play-rule-panel__title-text">{title}</span>
      </div>
      <div className="play-rule-panel__grid">
        {groups.map((group) => (
          <div
            key={group.label}
            className={`play-rule-panel__row${group.values.length > 12 ? ' play-rule-panel__row--wide' : ''}`}
          >
            <span className="play-rule-panel__label">{group.label}</span>
            <div className="play-rule-panel__values">
              {group.values.map((value, index) => (
                <span key={`${group.label}-${value}-${index}`} className="play-rule-panel__value">
                  {value}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PlayRuleLegend;
